namespace Areas.Scheduled {
    "use strict";
   

    function processMultiple(action) {


        var iCommentsEditor: any = $('#CommentsEditor').dxHtmlEditor('instance');
        var iComment = iCommentsEditor.option("value");
      
        var dataGrid = $('#InspectionScheduledGrid').dxDataGrid('instance');
        var dataIds = dataGrid.getSelectedRowKeys();
        if (dataIds.length === 0) {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
        else {
            var newData = {
                inspectionIds: dataIds,
                inspectorComment: iComment
            };

            const data = JSON.stringify(newData);
            const url = `/Inspectors/Scheduled/${action}`;

            sendRequest(url, data, "PUT", () => {
                refreshData(dataGrid); 
                clearComment();
            });

        }

    }


    function clearComment() {
        var iCommentsEditor: any = $('#CommentsEditor').dxHtmlEditor('instance');
        iCommentsEditor.option("value", null);
    }

    export function accept() {
        
        processMultiple('AcceptMultiple');
    }

    export function reject() {

        processMultiple('RejectMultiple');
    }

    export function save() {

        processMultiple('SaveForLaterMultiple');
    }

    export function returned() {

        var verifyVOID = window.confirm("Are you sure you would like to RETURN TO USER these records?");

        if (verifyVOID = true) {
            processMultiple('ReturnToUserMultiple');
        }
    }

    export function deleteRecord() {
        var verifyVOID = window.confirm("Are you sure you would like to VOID these records?");

        if (verifyVOID = true) {
            processMultiple('VoidMultiple');
        }
    }



}
